import gql from 'graphql-tag';

export default gql`
  query invitationSlot {
    invitationSlot {
      slot
    }
  }
`;
